/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserActionLogDto
 */
export interface UserActionLogDto {
    /**
     *
     * @type {number}
     * @memberof UserActionLogDto
     */
    userActionLogId?: number;
    /**
     *
     * @type {string}
     * @memberof UserActionLogDto
     */
    organisationId?: string;
    /**
     *
     * @type {number}
     * @memberof UserActionLogDto
     */
    userAccountId?: number;
    /**
     *
     * @type {string}
     * @memberof UserActionLogDto
     */
    username?: string;
    /**
     *
     * @type {string}
     * @memberof UserActionLogDto
     */
    platformSource?: string;
    /**
     *
     * @type {string}
     * @memberof UserActionLogDto
     */
    ipAddress?: string;
    /**
     *
     * @type {string}
     * @memberof UserActionLogDto
     */
    endpoint?: string;
    /**
     *
     * @type {string}
     * @memberof UserActionLogDto
     */
    paramsJson?: string;
    /**
     *
     * @type {string}
     * @memberof UserActionLogDto
     */
    targetDeviceIdentity?: string;
    /**
     *
     * @type {number}
     * @memberof UserActionLogDto
     */
    targetUserAccountId?: number;
    /**
     *
     * @type {string}
     * @memberof UserActionLogDto
     */
    logMessage?: string;
    /**
     *
     * @type {number}
     * @memberof UserActionLogDto
     */
    resultErrorNo?: number;
    /**
     *
     * @type {string}
     * @memberof UserActionLogDto
     */
    resultMessage?: string;
    /**
     *
     * @type {number}
     * @memberof UserActionLogDto
     */
    resultIdentity?: number;
    /**
     *
     * @type {string}
     * @memberof UserActionLogDto
     */
    resultIdentityStr?: string;
    /**
     *
     * @type {Date}
     * @memberof UserActionLogDto
     */
    createdAt?: Date;
    /**
     *
     * @type {string}
     * @memberof UserActionLogDto
     */
    userAgent?: string;
}

/**
 * Check if a given object implements the UserActionLogDto interface.
 */
export function instanceOfUserActionLogDto(
    value: object,
): value is UserActionLogDto {
    return true;
}

export function UserActionLogDtoFromJSON(json: any): UserActionLogDto {
    return UserActionLogDtoFromJSONTyped(json, false);
}

export function UserActionLogDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UserActionLogDto {
    if (json == null) {
        return json;
    }
    return {
        userActionLogId:
            json["userActionLogId"] == null
                ? undefined
                : json["userActionLogId"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        userAccountId:
            json["userAccountId"] == null ? undefined : json["userAccountId"],
        username: json["username"] == null ? undefined : json["username"],
        platformSource:
            json["platformSource"] == null ? undefined : json["platformSource"],
        ipAddress: json["ipAddress"] == null ? undefined : json["ipAddress"],
        endpoint: json["endpoint"] == null ? undefined : json["endpoint"],
        paramsJson: json["paramsJson"] == null ? undefined : json["paramsJson"],
        targetDeviceIdentity:
            json["targetDeviceIdentity"] == null
                ? undefined
                : json["targetDeviceIdentity"],
        targetUserAccountId:
            json["targetUserAccountId"] == null
                ? undefined
                : json["targetUserAccountId"],
        logMessage: json["logMessage"] == null ? undefined : json["logMessage"],
        resultErrorNo:
            json["resultErrorNo"] == null ? undefined : json["resultErrorNo"],
        resultMessage:
            json["resultMessage"] == null ? undefined : json["resultMessage"],
        resultIdentity:
            json["resultIdentity"] == null ? undefined : json["resultIdentity"],
        resultIdentityStr:
            json["resultIdentityStr"] == null
                ? undefined
                : json["resultIdentityStr"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        userAgent: json["userAgent"] == null ? undefined : json["userAgent"],
    };
}

export function UserActionLogDtoToJSON(value?: UserActionLogDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        userActionLogId: value["userActionLogId"],
        organisationId: value["organisationId"],
        userAccountId: value["userAccountId"],
        username: value["username"],
        platformSource: value["platformSource"],
        ipAddress: value["ipAddress"],
        endpoint: value["endpoint"],
        paramsJson: value["paramsJson"],
        targetDeviceIdentity: value["targetDeviceIdentity"],
        targetUserAccountId: value["targetUserAccountId"],
        logMessage: value["logMessage"],
        resultErrorNo: value["resultErrorNo"],
        resultMessage: value["resultMessage"],
        resultIdentity: value["resultIdentity"],
        resultIdentityStr: value["resultIdentityStr"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        userAgent: value["userAgent"],
    };
}
